<template>
  <v-btn
    x-small
    rounded
    outlined
    :disabled="disable"
    class="boostBtn"
    :class="{ active: activated && !disable, disable: disable }"
    @click="boostActivation"
    >boost</v-btn
  >
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      boost: false
    }
  },
  methods: {
    ...mapActions('vehicle', ['boostVehicle']),
    boostActivation () {
      this.boostVehicle({ activate: !this.activated, idTransaction: this.idTransaction, idVehicle: this.idVehicle })
    }
  },

  props: {
    activated: { type: Boolean, required: true },
    idTransaction: { type: String, required: true },
    idVehicle: { type: String, required: true },
    disable: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.boostBtn {
  color: #10367a;
  display: block;
  width: 90px;
  height: 26px;
  background-color: white;
}
.boostBtn:hover {
  border-color: #fe5815;
  background-color: #fe5815;
  color: #f9f9f9;
}
.active {
  border-color: #fe5815;
  background-color: #fe5815;
  color: #f9f9f9 !important;
}

.disable {
  border-color: #959595;
  color: #959595 !important;
}

.active:hover {
  border-color: #10367a;
  background-color: #f9f9f9;
  color: #10367a !important;
}
</style>
